import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { companySearchShape, useAccountingCompany } from "../../../features/accounting/company.js";
import { CounterpartyForm } from "../../../features/counterparties/counterparty-form.js";
import { CounterpartyPage, useListCrumb } from "../../../features/counterparties/shared.js";

export const Route = createFileRoute("/_app/cari/yeni")({
  validateSearch: (search) => z.object(companySearchShape).parse(search),
  component: NewCounterpartyPage,
});

function NewCounterpartyPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const listCrumb = useListCrumb();
  const { companies } = useAccountingCompany();
  return (
    <CounterpartyPage
      title={t("counterparties.list.new")}
      description={t("counterparties.form.description")}
      breadcrumb={[listCrumb, { label: t("counterparties.list.new") }]}
    >
      {({ companyId }) => (
        <CounterpartyForm
          companies={companies}
          defaultCompanyId={companyId}
          onSaved={(card) => void navigate({ to: "/cari/$id", params: { id: card.id } })}
        />
      )}
    </CounterpartyPage>
  );
}
